/*
 * Copyright (c) 2025-2026. Saddhu
 * Project: shopify-impulse
 * File: matomoTrackEvent.js
 * Date: 2026/6/11 16:37
 * Author: Saddhu
 */

var _paq = window._paq = window._paq || [];
var page_type = window.theme.page_type || ''
var page_handle = window.theme.page_handle || ''
// 产品加购信息
try {

	document.addEventListener('ajaxProduct:added',(ev)=>{
		const product = ev.detail.product
		const productList = ev.detail.productList
		if (!product && !productList?.length)return
		if (product){
			localCartAddItem(product.id)
		}else if (productList){
			productList.forEach(item => {
				localCartAddItem(item.product.id)
			})
		}
	})
	document.addEventListener('cart:updated',(ev)=>{
		const cart = ev.detail.cart
		localCartUpdateItem(cart.items)
	})

	function localCartAddItem(id,type='ajax'){
		const localCartStr = localStorage.getItem('localCart') || '[]'
		const hrefLogStr = sessionStorage.getItem('href_log') || '{}';
		let localCart =JSON.parse(localCartStr)
		const hrefLog = JSON.parse(hrefLogStr)
		if (!id){return}
		let item = localCart.find(item=>item.id === id && item.type === type)
		if (!item){
			localCart.push({
				id:id,
				type:type,
				prev:hrefLog.prev,
				current:hrefLog.current,
				landing:hrefLog.landing,
			})
		}

		localStorage.setItem('localCart',JSON.stringify(localCart))
	}
	function localCartUpdateItem (cartItems=[]){
		const localCartStr = localStorage.getItem('localCart') || '[]'
		let localCart =JSON.parse(localCartStr)
		let newLocalCart = [];
		cartItems.forEach(cartItem =>{
			const localItemIndex = localCart.findIndex(localItem => localItem.id == cartItem.id && localItem.type === 'ajax' );
			// 页面正常ajax添加的 用购物车行id进行筛选
			if(localItemIndex >= 0){
				newLocalCart.push({...localCart[localItemIndex]})
				localCart.splice(localItemIndex,1)
			}else{
			//	购物车行id匹配不到的,用variant_id进行匹配
				const localSKUIndex = localCart.findIndex( localItem=> localItem.id == cartItem.variant_id && localItem.type !== 'ajax');
				if (localSKUIndex >=0 ){
					newLocalCart.push({...localCart[localSKUIndex]})
					// 	匹配完成后删除已匹配过的元素
					localCart.splice(localSKUIndex,1)
				}
			}
		})
		localStorage.setItem('localCart',JSON.stringify(newLocalCart))
	}

	function getUtmStr(url){
		// 移除旧版本数据
		sessionStorage.removeItem('@micas-last-utm');
		const urlObj = url ? new URL(url) : window.location;
		const params = new URLSearchParams(urlObj?.search)
		if (params.has('utm_source')) {
			const utmObj = {
				utm_source: params.get('utm_source') || 'null',
				utm_medium: params.get('utm_medium') || 'null',
				utm_campaign: params.get('utm_campaign') || 'null',
				utm_term: params.get('utm_term') || 'null',
				utm_content: params.get('utm_content') || 'null',
				is_current_link: true
			}
			sessionStorage.setItem('@micas-lastUTM', JSON.stringify({ ...utmObj, is_current_link: false }));
			return `${utmObj.utm_source}#@#${utmObj.utm_medium}#@#${utmObj.utm_campaign}#@#${utmObj.utm_term}#@#${utmObj.utm_content}#@#${utmObj.is_current_link}`
		}
		const sessionUtmStr = sessionStorage.getItem('@micas-lastUTM') || '{}';
		const sessionUtm = JSON.parse(sessionUtmStr);
		if(sessionUtm.utm_source){
			return `${sessionUtm.utm_source}#@#${sessionUtm.utm_medium}#@#${sessionUtm.utm_campaign}#@#${sessionUtm.utm_term}#@#${sessionUtm.utm_content}#@#${sessionUtm.is_current_link}`
		} else {
			return ''
		}
	}


	~function () {

		/*
		* window.theme.config.bpSmall  // 是否是small屏幕，
		* page_type	// 当前页面类型
		* 自定义维度
		* 1.元素序号 index
		* 2.网络状况(访问者维度)
		* 3.媒体链接 url
		* 4.跳转链接 href
		* 5.产品sku sku
		* 6.产品尺码 size
		* 7.产品颜色 color
		* 8.产品价格 price
		* 9.引流页面 landing
		* 10.前置页面 prev
		* 11.当前页面 current
		* 12.设备类型 pc | mobile
		* 13.事件类别 category
		* 14.事件操作 action
		* 15.事件名称 name
		* 16.事件值 value
		* 17.shopify用户id
		* 18.最后一个集合页(网页端为空)
		* 19.shopify用户email
		* 20. 用户分组
		* 21.utm 参数
		* 22.URL 关键参数
		* */


		/*
		* (必填)container:事件代理容器 CSS选择器，dom节点
		* event: 事件触发名称 load、sync、click/change...原生事件，默认click

		* (必填)category: 上报类别
		* categoryKey：上报类别自定义数据key 默认matomoCategory
		* (必填)target：事件上报操作，用于匹配节点属性data-matomo
		* disableKey 禁用上报标识自定义数据key 默认matomoDisable
		* debug 是否开启debug
		* delayed 是否延时
		* delayTime 延时事件 ms
		* customData 自定义数据函数，带返回值的函数，参数（触发节点，容器）
		* customTarget 自定义目标节点
		* prevFn 上报之前额外处理函数
		* callback 上报结束后回调函数，参数（触发节点，容器）
		*
		* 节点绑定属性
		* data-matomo 操作名
		* data-matomo-name 上报目标标识
		* data-matomo-action 上报事件操作，缺省使用data-matomo值
		* data-matomo-mobile-name 上报移动端名称
		* data-matomo-index 自定义维度序号
		* data-matomo-url 自定义维度媒体链接,统一  | image_url | split: "?" | first
		* data-matomo-mobile-url 自定义维度移动端媒体链接
		* data-matomo-href	自定义维度跳转链接
		* data-matomo-sku	自定义维度sku
		* data-matomo-size	自定义维度尺码
		* data-matomo-color	自定义维度颜色
		* data-matomo-disable 禁用上报
		* */

		let bomType = 'pc';
		if (theme?.config?.bpSmall){
			bomType = 'mobile'
		}
		// utm 参数
		const utmStr = getUtmStr()

		class MatomoHandle {
			constructor(obj) {
				if (typeof (obj.container) === 'string') {
					this.container = document.querySelector(obj.container);
				} else {
					this.container = obj.container;
				}
				this.event = obj.event || 'click';//事件触发名称
				this.category = obj.category || 'click';//事件上报类别
				this.target = obj.target || ''; //元素匹配标识
				this.disableKey = obj.disableKey || 'matomoDisable';//禁用上报标识
				//是否开启debug
				this.delayed = obj.delayed || false; //是否延时
				this.delayTime = obj.delayTime || 300; //延时时间
				this.customData = obj.customData || function () {
					return {}
				};
				this.customTarget = obj.customTarget || null;
				this.callback = obj.callback || function () {
					return false
				};
				this.prevFn = obj.prevFn || function () {
					return false
				};
				this.ABGroup = "A"
				if (document.documentElement.classList.contains('abtest-b')){
					this.ABGroup = "B"
				}
				this.bind()
			}

			bind() {
				if (!this.container) {
					return false;
				}
				if (this.event === "load") {
					window.addEventListener('load', (ev) => {
						this.handle(this.container);
					})
				} else if (this.event === 'sync') {
					this.handle(this.container);
				}  else if (this.event === 'repeat') {
					let domList = this.container.querySelectorAll(this.target);
					let that = this;
					domList.forEach(item => {
						new MatomoHandle({
							container: item,
							event: "sync",
							category : that.category,
							disableKey : that.disableKey,
							debug : that.debug ,
							delayed : that.delayed ,
							delayTime : that.delayTime,
							customData : that.customData ,
							customTarget : that.customTarget ,
							callback : that.callback ,
							prevFn : that.prevFn ,
						})
					})
				}else {
					this.container.addEventListener(this.event, (ev) => {
						if (this.delayed) {
							setTimeout(() => {
								let el = this.getTarget(ev);
								if (!el) {
									return
								}
								this.handle(el)
							}, this.delayTime)
						} else {
							let el = this.getTarget(ev);
							if (!el) {
								return
							}
							this.handle(el,ev)
						}
					})
				}
			}

			getTarget(ev) {
				let targetEl = null;
				if (this.customTarget) {
					targetEl = this.customTarget(ev,this.container);
				} else {
					targetEl = ev?.target;
					if (targetEl && targetEl.dataset && targetEl.dataset?.matomo !== this.target) {
						targetEl = ev.target.closest(`[data-matomo='${this.target}']`)
					}
				}
				let disable = false
				if (targetEl && targetEl.dataset) {
					disable = targetEl.dataset[this.disableKey];
				}
				return disable ? false : targetEl;
			}

			handle(el,ev) {
				let data = this.getData(el,ev)
				this.prevFn(el, data,this.container,ev,);
				if (Object.keys(data).length) {
					this.sendData(data);
				}
				this.sendEnd(el);
				this.callback(el, this.container,ev);
			}

			getData(el,ev) {
				let action = el?.dataset?.matomoAction || '';
				if (action === '') {
					action = el?.dataset?.matomo || '';
				}
				let name = el?.dataset?.matomoName || '';
				let value = el?.dataset?.matomoValue || 1;
				value = value * 1;
				let index = el?.dataset?.matomoIndex || '';

				const isAB = el?.dataset?.abtest
				if (isAB !== undefined){
					if (this.ABGroup === 'A'){
						index = el?.dataset?.matomoIndexA || index;
					}else {
						index = el?.dataset?.matomoIndexB || index;
					}
				}
				let url = el?.dataset?.matomoUrl || '';
				const rawHref = el?.getAttribute('href') || ''
				const elHref = (rawHref === '#' || rawHref.startsWith('javascript:')) ? '' : el?.href || ''
				const href = el?.dataset?.matomoHref || elHref;
				const sku = el?.dataset?.matomoSku || '';
				const size = el?.dataset?.matomoSize || '';
				const color = el?.dataset?.matomoColor || '';
				const price = el?.dataset?.matomoPrice || '';
				let mobileName = el?.dataset?.matomoMobileName || '';
				let mobileUrl = el?.dataset?.matomoMobileUrl || '';
				if (window.theme.config.bpSmall) {
					name = mobileName ? mobileName : name;
					url = mobileUrl ? mobileUrl : url;
				}
				let data = {
					category: this.category,
					action,
					name,
					value,
					index,
					url,
					href,
					sku,
					size,
					color,
					price,
					utmStr:utmStr
				}
				const newDta = this.customData(el, this.container,ev)
				return Object.assign(data, newDta)
			}

			sendData(data) {
				const _paq = window._paq = window._paq || [];
				let type = 'pc';
				if (theme?.config?.bpSmall){
					type = 'mobile'
				}
				const hrefLogStr = sessionStorage.getItem('href_log') || '{}';
				const hrefLog = JSON.parse(hrefLogStr)
				const micas_uuid = localStorage.getItem('@micas-browser-id')
				let dimensions ={
					dimension1: data.index || '',
					dimension3: data.url,
					dimension4: data.href,
					dimension5: data.sku,
					dimension6: data.size,
					dimension7: data.color,
					dimension8: data.price,
					dimension9: data.landing || hrefLog?.landing || "",
					dimension10: data.prev || hrefLog?.prev || "",
					dimension11: data.current || hrefLog?.current || "",
					dimension12: type,
					dimension13: data.category,
					dimension14: data.action,
					dimension15: data.name,
					dimension16: data.value || 1,
					dimension17: data.shopifyId || '',
					dimension19: data.shopifyEmail  || '',
					dimension20: `${window.customerGroup}#@#${window.customerGroupOps}`,
					dimension21: data.utmStr,
					dimension23: micas_uuid,
					dimension24: micas_uuid,
				}
				const unit = Shopify.currency?.active || ''
				if (dimensions.dimension8 !== "" ){
					dimensions.dimension8 = `${unit} ${parseFloat(dimensions.dimension8).toFixed(2)}`
				}
				for (const dimensionsKey in dimensions) {
					if (dimensions[dimensionsKey] === ""){
						delete dimensions[dimensionsKey];
					}
				}
				_paq.push([
					"trackEvent",
					data.category,
					data.action,
					data.name,
					data.value || 1,
					dimensions
				])
			}

			sendEnd(el) {
				el.dataset[this.disableKey] = '1';
			}
		}

		// 自定义内容跟踪 (自带跟踪无法跟踪滚动容器以及弹窗)
		/*
		* (必填)container:事件代理容器 CSS选择器，dom节点
		* 用于匹配节点属性 data-matomo-content
		* */
		class MatomoContent {
			constructor(container) {
				if (typeof (container) === 'string') {
					this.container = document.querySelector(container);
				} else {
					this.container = container;
				}
				this.init();
			}
			init() {
				this.ABGroup = "A"
				if (document.documentElement.classList.contains('abtest-b')){
					this.ABGroup = "B"
				}
				this.matomoObserver= new IntersectionObserver((entries)=>{
					entries.forEach((entry) => {
						const target = entry.target;
						if (
							entry.isIntersecting
							&& window.getComputedStyle(target).visibility !== 'hidden'
							&& window.getComputedStyle(target).display !== 'none'
						) { // 目标元素出现在 root 可视区，并且可见 返回 true
							this.track(target);
							this.matomoObserver.unobserve(target);
						}
					})
				}, {
					threshold: [0.25]
				});
				this.bind();
			}
			bind() {
						if (!this.container) {
					return false;
				}
				const contentElList = this.container.querySelectorAll('[data-matomo-content]');
						contentElList.forEach(item => {
								if (!item.dataset.matomoContentTracked){
						this.matomoObserver.observe(item);
						item.dataset.matomoContentTracked= 'observer';
					}
				})

			}
			track(target) {
				let contentName = target.dataset.contentName;
				let contentPiece = target.dataset.contentPiece;
				const isAB = target.dataset.abtest
				if (isAB !== undefined){
					if (this.ABGroup === 'A'){
						contentPiece = target.dataset.contentPieceA ? target.dataset.contentPieceA : contentPiece;
						contentName = target.dataset.contentNameA ? target.dataset.contentNameA : contentName;
					}else {
						contentPiece = target.dataset.contentPieceB ? target.dataset.contentPieceB : contentPiece;
						contentName = target.dataset.contentNameB ? target.dataset.contentNameB : contentName;
					}
				}
				let contentTarget = target.dataset.contentTarget
				if (!contentTarget) {
					const a = target.closest('a');
					if (a){
						contentTarget = a.getAttribute('href');
					}
				}
				_paq.push(['trackContentImpression', contentName, contentPiece, contentTarget]);
				target.dataset.matomoContentTracked= 'tracked';
			}
		}

		//自定义曝光监听
		new MatomoContent('#PageContainer');
			//邮递提醒弹窗曝光监听
		new MatomoContent('.micas-shipping-tip-popup');
		// 集合页重新加载曝光
		document.addEventListener("collection:reloaded", () => {
			new MatomoContent('#PageContainer');
		})
		// 集合页加载更多 重新绑定曝光
		document.addEventListener("collection:fetchMore", () => {
			new MatomoContent('#PageContainer');
		})
		// 加载更多模块 重新绑定曝光
		document.addEventListener("featured:fetchMore", () => {
			new MatomoContent('.featured-collection-auto-load');
		})
		// 购物车自定义曝光
		document.addEventListener('cart:updated', () => {
			new MatomoContent('#CartDrawer');
		})


		// 买赠弹窗
		~function (){
			const buyGetDrawer = document.querySelector('#BuyGetDrawer')
			const giftHandles = buyGetDrawer?.dataset?.giftHandles
			const giftMessage = buyGetDrawer?.dataset?.giftMessage
			const contentName = `site#@#pop#@#freegift#@#${giftMessage}#@#1#@#pc/mobile`
			// 曝光
			if(buyGetDrawer){
				buyGetDrawer.addEventListener('drawerOpen', () => {
					_paq.push(['trackContentImpression', contentName, giftMessage, giftHandles]);
				})
			}
			document.addEventListener('modalOpen.BuyGetModal', () => {
				_paq.push(['trackContentImpression', contentName, giftMessage, giftHandles]);
			})
			// 	打开
			new MatomoHandle({
				container: '#CartDrawer',
				category: 'popClick',
				target: 'pop#@#freegiftopen',
				customData: () => {
					return {
						name: giftMessage,
						url: giftHandles
					}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			// 	关闭
			new MatomoHandle({
				container: '#BuyGetDrawer',
				category: 'popClick',
				target: 'pop#@#freegiftclose',
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			new MatomoHandle({
				container: '#BuyGetModal',
				category: 'popClick',
				target: 'pop#@#freegiftclose',
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			// 	加购
			document.addEventListener('buyGetAdd', (ev) => {
				const variant = ev.detail?.variant;
				const index = ev.detail?.index;
				const spu = ev.detail?.spu;
				new MatomoHandle({
					container: document.documentElement,
					category: 'addToCartClick',
					event: 'sync',
					customData: () => {
						let data = {
							action: 'pop#@#addfreegift',
							name: spu,
							value: 1,
							index: index,
							url: variant.featured_image.src,
							sku: variant.sku,
							color: variant.option1,
							size: variant.option2,
							price: (variant?.price / 100).toFixed(2),
						}
						return {...data}
					}
				})
			})
			// 	sku 切换
			new MatomoHandle({
				container: window.document,
				category: 'skuChange',
				target: 'skuChange',
				event: 'variant:change:buyGet',
				customTarget: () => {
					return document.createElement('div');
				},
				customData: (_, __, ev) => {
					const { variant, optionIndex, optionValue, target } = ev.detail;
					return {
						action: 'pop#@#freegift',
						name: `${target.dataset?.handle || ''}`,
						value: 1,
						index: target.dataset?.index || 1,
						url:target.dataset?.featured_image || '',
						sku: `${variant.sku}`,
						...(optionIndex == 1 ? { size: optionValue } : {}),
						...(optionIndex == 0 ? { color: optionValue } : {}),
						price: (variant.price/100).toFixed(2),
					}
				},
			})
		}()


		// 页面浏览
		new MatomoHandle({
			container: document.documentElement,
			category: 'pageView',
			event: 'sync',
			customData: () => {
				let data = {
					action: window?.theme?.page_handle ||  window?.theme?.page_type,
					name: `${location.origin}${location.pathname}`,
					value: 1,
					url: location.href
				}
				return {...data}
			}
		})

		// 顶部icon
		new MatomoHandle({
			container: '#SiteHeader .site-header-nav-bar',
			category: 'menuClick',
			target: 'site#@#headerIcon',
			event: 'drawerOpen',
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
		// 顶部logo
		new MatomoHandle({
			container: '#SiteHeader .site-header-nav-bar',
			category: 'menuClick',
			target: 'headerLogo',
		})

		new MatomoHandle({
			container: '#SiteHeader .site-nav__link--icon-wishlist',
			category: 'menuClick',
			target: 'site#@#headerIcon',

		})
		// 个人中心菜单点击
		new MatomoHandle({
			container: '#SiteHeader .site-nav-user .site-nav-user__dropdown',
			category: 'menuClick',
			target: 'site#@#headerUser',
		})
		// 汉堡菜单社媒icon
		new MatomoHandle({
			container: '#NavDrawer .mobile-nav__social',
			category: 'menuClick',
			target: 'site#@#drawerSocialIcon',
		})
		// 底部菜单菜单社媒icon
		new MatomoHandle({
			container: '#shopify-section-footer',
			category: 'menuClick',
			target: 'site#@#footerSocialIcon',
		})
		// 购物车banner 点击
		new MatomoHandle({
			container: "#CartDrawer",
			category: 'bannerClick',
			target: 'cart#@#cart_act'
		})

		// 顶部菜单
		new MatomoHandle({
			container: ".site-navigation",
			category: 'menuClick',
			target: 'site#@#mainMenu',
		})
		// 移动端顶部菜单
		new MatomoHandle({
			container: ".site-navigation-ph",
			category: 'menuClick',
			target: 'site#@#mainMenu_mobile',
		})
		// 底部菜单
		new MatomoHandle({
			container: "#shopify-section-footer .site-footer",
			category: 'menuClick',
			target: 'site#@#footerMenu'
		})
		// 侧边菜单
		new MatomoHandle({
			container: "#NavDrawer",
			category: 'menuClick',
			target: 'site#@#drawerMenu',
		})
		//搜索热词
		new MatomoHandle({
			container: "#SearchDrawer .hot-keyword",
			category: 'menuClick',
			target: 'site#@#searchHot',
		})

		//搜索推荐产品
		new MatomoHandle({
			container: '#SearchDrawer .custom-products-scroll-container',
			category: 'productCardClick',
			target: 'product_card',
			customData: (el) => {
				let data = {}
				const cartItem = el.closest('.matomo-product-container');
				if (cartItem) {
					data.action = "search#@#recommend";
					data.name = cartItem.dataset.matomoName || '';
					data.index = cartItem.dataset.matomoIndex || '';
					data.url = cartItem.dataset.matomoUrl || '';
					data.sku = cartItem.dataset.matomoSku || '';
					data.size = cartItem.dataset.matomoSize || '';
					data.color = cartItem.dataset.matomoColor || '';
					data.price = cartItem.dataset.matomoPrice || '';
				}
				return {...data}
			}
		})

		//快速预览按钮点击
		new MatomoHandle({
			container: window.document,
			category: 'quickViewClick',
			target: 'quickView',
			event: 'quickShopModalOpen',
			customTarget: (ev) => {
				const target = ev.detail?.target;
				return target || null;
			},
			customData: (el) => {
				let data = {}
				const gridItem = el.closest('.matomo-product-container');
				if (gridItem) {
					data.action = gridItem.dataset.matomoAction || '';
					data.name = gridItem.dataset.matomoName || '';
					data.index = gridItem.dataset.matomoIndex || '';
					data.url = gridItem.dataset.matomoUrl || '';
					data.sku = gridItem.dataset.matomoSku || '';
					data.size = gridItem.dataset.matomoSize || '';
					data.color = gridItem.dataset.matomoColor || '';
					data.price = gridItem.dataset.matomoPrice || '';
				}
				return {...data}
			},
			prevFn: (el,data)=>{
				//快速购买上报产品
				const gridItem = el.closest('.grid-product');
				if (gridItem) {
					const sku = gridItem.dataset.matomoSku || '';
					const price = gridItem.dataset.matomoPrice || '';
					const title = gridItem.dataset.matomoTitle || '';
					const collections = gridItem.dataset.matomoCollections || '';
					const collectionsArr = collections.split(',').slice(0,5);
					_paq.push([
						'setEcommerceView',
						sku,
						title,
						collectionsArr,
						price,
					]);
					_paq.push(['ping']);
				}

				// 上报产品浏览
				const unit = Shopify.currency?.active || ''
				let productViewPrice ;
				if (data.price !== "" ){
					productViewPrice = `${unit} ${parseFloat(data.price).toFixed(2)}`
				}
				const hrefLogStr = sessionStorage.getItem('href_log') || '{}';
				const hrefLog = JSON.parse(hrefLogStr)
				_paq.push([
					'trackEvent',
					'productView',
					'quickView#@#product',
					data.name,
					1,
					{
						dimension3: data.url,
						dimension5: data.sku,
						dimension6: data.size,
						dimension7: data.color,
						dimension8: productViewPrice,
						dimension9: data.landing || hrefLog?.landing || "",
						dimension10: data.prev || hrefLog?.prev || "",
						dimension11: data.current || hrefLog?.current || "",
						dimension12: bomType,
						dimension13: 'productView',
						dimension14: 'quickView#@#product',
						dimension15: data.name,
						dimension16: 	1,
					}
				]);
			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})

		//快速购买页加购按钮点击，分享按钮点击 统一处理
		new MatomoHandle({
			container: window.document,
			category: 'quickView',
			target: 'shareClick',
			customTarget: (ev) => {
				const evTarget = ev.target;
				const isModal = evTarget.closest('.modal--quick-shop');
				let targetEl = null
				if (isModal) {
					if (evTarget.dataset['data-matomo'] == 'addToCartClick' || evTarget.dataset['data-matomo'] == 'shareClick') {
						targetEl = evTarget
					}else{
						targetEl = evTarget.closest(`[data-matomo='addToCartClick'],[data-matomo='shareClick']`)
					}
				}
				return targetEl;
			},
			customData: (el) => {
				let data = {}
				data.category = el.dataset.matomo;
				const action = el.dataset.matomoAction;
				if (action){
					data.action = action.replace('product#@#','quickView#@#');
				}
				const cartItem = el.closest('.product-wrapper');
				if (cartItem) {
					data.name = cartItem.dataset.productHandle || '';
					data.url = cartItem.dataset.currentSkuImage || '';
					data.sku = cartItem.dataset.currentSku || '';
					data.size = cartItem.dataset.currentSize || '';
					data.color = cartItem.dataset.currentColor || '';
					data.price = cartItem.dataset.currentPrice || '';
				}
				return {...data}
			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})

		//快速购买变体切换点击
		new MatomoHandle({
			container: window.document,
			category: 'skuChange',
			target: 'skuChange',
			event: 'variant:change',
			customTarget: (ev) => {
				const container = ev.detail.container;
				let el = null;
				if (container && container.closest('.modal--quick-shop')) {
					const productWrapper = container.closest('.product-wrapper');
					const variant = ev.detail?.variant;
					if (variant && productWrapper) {
						el = document.createElement('div');
						el.dataset.matomoAction= 'quickView#@#product';
						el.dataset.matomoName = productWrapper.dataset.productHandle || '';
						el.dataset.matomoSku = variant.sku || '';
						el.dataset.matomoIndex = ev.detail.index || '';
						el.dataset.matomoUrl = variant.featured_image?.src || '';
						el.dataset.matomoColor = variant.option1 || '';
						el.dataset.matomoSize = variant.option2 || '';
						el.dataset.matomoPrice = (variant.price / 100).toFixed(2);
						el.dataset.matomoTitle = productWrapper.dataset.productTitle || '';
						el.dataset.matomoCollections = productWrapper.dataset.productCollections || '';
					}
				}
				return el;
			},
			prevFn: (el,data) => {
				//快速购买页变体切换上报电子商务产品
				const hrefLogStr = sessionStorage.getItem('href_log') || '{}';
				const hrefLog = JSON.parse(hrefLogStr)
				const collectionsArr = el.dataset.matomoCollections.split(',').slice(0,5);
				_paq.push([
					'setEcommerceView',
					el.dataset.matomoSku,
					el.dataset.matomoTitle,
					collectionsArr,
					el.dataset.matomoPrice,
				]);
				_paq.push(['ping']);

				// 上报产品浏览
				const unit = Shopify.currency?.active || ''
				let productViewPrice ;
				if (data.price !== "" ){
					productViewPrice = `${unit} ${parseFloat(data.price).toFixed(2)}`
				}
				_paq.push([
					'trackEvent',
					'productView',
					'quickView#@#product',
					data.name,
					1,
					{
						dimension3: data.url,
						dimension5: data.sku,
						dimension6: data.size,
						dimension7: data.color,
						dimension8: productViewPrice,
						dimension9: data.landing || hrefLog?.landing || "",
						dimension10: data.prev || hrefLog?.prev || "",
						dimension11: data.current || hrefLog?.current || "",
						dimension12: bomType,
						dimension13: 'productView',
						dimension14: 'quickView#@#product',
						dimension15: data.name,
						dimension16: 	1,
					}
				]);
			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
		//购物车产品点击、购物车推荐产品
		new MatomoHandle({
			container: '#CartDrawer',
			category: 'productCardClick',
			target: 'product_card',
			customData: (el) => {
				let data = {}
				const cartItem = el.closest('.matomo-product-container');
				if (cartItem) {
					data.action = cartItem.dataset.matomoAction || '';
					data.name = cartItem.dataset.matomoName || '';
					data.index = cartItem.dataset.matomoIndex || '';
					data.url = cartItem.dataset.matomoUrl || '';
					data.sku = cartItem.dataset.matomoSku || '';
					data.size = cartItem.dataset.matomoSize || '';
					data.color = cartItem.dataset.matomoColor || '';
					data.price = cartItem.dataset.matomoPrice || '';
				}
				return {...data}
			}
		})

		//购物车推荐产品加购点击
		new MatomoHandle({
			container: '#CartDrawer',
			category: 'addToCartClick',
			target: 'cart_recommend_add',
			customData: (el) => {
				let data = {}
				data.action = 'cart#@#recommend';
				const cartItem = el.closest('.matomo-product-container');
				if (cartItem) {
					data.action = cartItem.dataset.matomoAction || 'cart#@#recommend';
					data.name = cartItem.dataset.matomoName || '';
					data.index = cartItem.dataset.matomoIndex || '';
					data.url = cartItem.dataset.matomoUrl || '';
					data.sku = cartItem.dataset.matomoSku || '';
					data.size = cartItem.dataset.matomoSize || '';
					data.color = cartItem.dataset.matomoColor || '';
					data.price = cartItem.dataset.matomoPrice || '';
				}
				return {...data}
			}
		})
		new MatomoHandle({
			container: '#CartDrawer',
			category: 'addToCartClick',
			target: 'cart_variant_select_submit',
			customData: (el) => {
				let data = {}
				const selectContainer = el.closest('.cartVariantSelect');
				const type = selectContainer?.dataset?.type;
				data.action = selectContainer?.dataset.matomoAction || 'cart#@#item';
				data.name = selectContainer?.dataset.spu || '';
				data.value = selectContainer?.dataset.oldQuantity || '';
				data.index = 1;
				data.url = el?.dataset.featured_image || '';
				data.sku = el?.dataset.sku || '';
				data.size = el?.dataset.option1 || '';
				data.color = el?.dataset.option2 || '';
				data.price = el?.dataset.price || '';
				if (type ==='update'){
					const oldFeatured_image = selectContainer?.dataset.oldFeatured_image;
					const oldSku = selectContainer?.dataset.oldSku;
					const oldColor = selectContainer?.dataset.oldOption1;
					const oldSize = selectContainer?.dataset.oldOption2;
					const oldPrice = selectContainer?.dataset.oldPrice;
					const oldIndex = selectContainer?.dataset.oldIndex;
					const hrefLogStr = sessionStorage.getItem('href_log') || '{}';
					const hrefLog = JSON.parse(hrefLogStr);
					_paq.push([
						'trackEvent',
						'removeFromCartClick',
						'cart#@#item',
						data.name,
						data.value,
						{
							dimension1: oldIndex,
							dimension3: oldFeatured_image,
							dimension5: oldSku,
							dimension6: oldSize,
							dimension7: oldColor,
							dimension8: oldPrice,
							dimension9: data.landing || hrefLog?.landing || "",
							dimension10: data.prev || hrefLog?.prev || "",
							dimension11: data.current || hrefLog?.current || "",
							dimension12: bomType,
							dimension13: 'removeFromCartClick',
							dimension14: 'cart#@#item',
							dimension15: data.name,
							dimension16: 	data.value,
						}
					]);
				}
				return {...data}
			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})

		//购物车+号点击加购
		new MatomoHandle({
			container: '#CartDrawer',
			category: 'addToCartClick',
			target: 'quantity-plus-btn',
			customData: (el) => {
				let data = {}
				data.action = 'cart#@#button';
				const cartItem = el.closest('.matomo-product-container');
				if (cartItem) {
					data.name = cartItem.dataset.matomoName || '';
					data.index = cartItem.dataset.matomoIndex || '';
					data.url = cartItem.dataset.matomoUrl || '';
					data.sku = cartItem.dataset.matomoSku || '';
					data.size = cartItem.dataset.matomoSize || '';
					data.color = cartItem.dataset.matomoColor || '';
					data.price = cartItem.dataset.matomoPrice || '';
				}
				return {...data}
			}
		})
		//购物车-号点击取消加购
		new MatomoHandle({
			container: '#CartDrawer',
			category: 'removeFromCartClick',
			target: 'quantity-minus-btn',
			customData: (el) => {
				let data = {}
				data.action = 'cart#@#button';
				const cartItem = el.closest('.matomo-product-container');
				if (cartItem) {
					data.name = cartItem.dataset.matomoName || '';
					data.index = cartItem.dataset.matomoIndex || '';
					data.url = cartItem.dataset.matomoUrl || '';
					data.sku = cartItem.dataset.matomoSku || '';
					data.size = cartItem.dataset.matomoSize || '';
					data.color = cartItem.dataset.matomoColor || '';
					data.price = cartItem.dataset.matomoPrice || '';
				}
				return {...data}
			}
		})

		//购物车数量输入增加加购/减少取消加购
		new MatomoHandle({
			container: '#CartDrawer',
			category: 'addToCartClick',
			target: 'quantity-input',
			event:'change',
			customData: (el) => {
				let data = {}
				data.action = 'cart#@#input';
				if (el.defaultValue>el.value){
					data.category = 'removeFromCartClick';
				}
				data.value = Math.abs(el.defaultValue - el.value);
				const cartItem = el.closest('.matomo-product-container');
				if (cartItem) {
					data.name = cartItem.dataset.matomoName || '';
					data.index = cartItem.dataset.matomoIndex || '';
					data.url = cartItem.dataset.matomoUrl || '';
					data.sku = cartItem.dataset.matomoSku || '';
					data.size = cartItem.dataset.matomoSize || '';
					data.color = cartItem.dataset.matomoColor || '';
					data.price = cartItem.dataset.matomoPrice || '';
				}
				return {...data}
			}
		})

		//加购结果
		new MatomoHandle({
			container: window.document,
			category: 'addToCartResult',
			target: 'addToCartResult',
			event:'ajaxProduct:added',
			customTarget: (ev) => {
				const sku = ev.detail.sku|| ''
				let el = null;
				let name = 	'success';
				if (sku) {
					el = document.createElement('div');
					el.dataset.matomoAction= sku;
					el.dataset.matomoName = name;
				}
				return el;
			},
		})
		new MatomoHandle({
			container: window.document,
			category: 'addToCartResult',
			target: 'addToCartResult',
			event:'ajaxProduct:error',
			customTarget: (ev) => {
				const sku = ev.detail.sku|| ''
				let el = null;
				let name = 	ev.detail?.errorMessage||'';
				if (sku) {
					el = document.createElement('div');
					el.dataset.matomoAction= sku;
					el.dataset.matomoName = name;
				}
				return el;
			},
		})


		//购物车变体切换点击,购物车推荐产品变体切换点击
		new MatomoHandle({
			container: '#CartDrawer .cartVariantSelect',
			category: 'skuChange',
			target: 'skuChange',
			event:'matomoVariantChange',
			customTarget: (ev) => {
				const container = ev.detail.container;
				let el = null;
				const variant = ev.detail?.variant;
				if (variant) {
					el = document.createElement('div');
					el.dataset.matomoAction = container.dataset.scopeName || 'cart#@#item';
					el.dataset.matomoName = container.dataset.spu||'';
					el.dataset.matomoSku = variant.sku || '';
					el.dataset.matomoIndex = ev.detail.index || '';
					el.dataset.matomoUrl = variant.featured_image?.src || '';
					el.dataset.matomoColor = variant.option1 || '';
					el.dataset.matomoSize = variant.option2 || '';
					el.dataset.matomoPrice = (variant.price / 100).toFixed(2);
				}
				return el
			}
		})

		//checkout按钮点击 上报每个产品
		~function () {
			const checkout_btn = document.querySelector('#CartDrawer .cart__checkout');
			const checkout_without_insurance_btn = document.querySelector('#CartDrawer .cart__checkout--without-insurance');
			
			const func = (btn) => {
				if (btn.dataset?.matomoDisable === 'true'){return}
				btn.dataset.matomoDisable='true';
				sessionStorage.setItem('currentCheckoutStep', 'Checkout');
				const localCartStr = localStorage.getItem('localCart') || '[]'
				let localCart =JSON.parse(localCartStr)
				new MatomoHandle({
					container: '#CartDrawer',
					category: 'checkout',
					target: '#CartDrawer .cart__items .cart__item',
					event:'repeat',
					customData: (el,container) => {
						let data = {}
						data.action = 'cart#@#product';
						data.name = container.dataset.matomoName || '';
						const value = container.dataset.quantity || 1;
						data.value = value * 1;
						data.index = container.dataset.matomoIndex || '';
						data.url = container.dataset.matomoUrl || '';
						data.sku = container.dataset.matomoSku || '';
						data.size = container.dataset.matomoSize || '';
						data.color = container.dataset.matomoColor || '';
						data.price = container.dataset.matomoPrice || '';
						const id  = el.dataset.id;
						const variant_id = el.dataset.variantId;
						let localCartItem = {};
						const localItemIndex = localCart.findIndex(localItem => localItem.id == id && localItem.type === 'ajax' );
						if(localItemIndex >= 0){
							localCartItem = {...localCart[localItemIndex]}
							localCart.splice(localItemIndex,1)
						}else{
							//	购物车行id匹配不到的,用variant_id进行匹配
							const localSKUIndex = localCart.findIndex( localItem=> localItem.id == variant_id && localItem.type !== 'ajax');
							if (localSKUIndex >=0 ){
								localCartItem = {...localCart[localSKUIndex]}
								localCart.splice(localItemIndex,1)
							}
						}
						data.landing =localCartItem.landing || '';
						data.prev =localCartItem.prev || '';
						data.current = localCartItem.current || '';
						return data;
					}
				})
			}
			
			if (checkout_btn){
				checkout_btn.addEventListener('click',()=> func(checkout_btn))
			}
			if (checkout_without_insurance_btn){
				checkout_without_insurance_btn.addEventListener('click',()=> func(checkout_without_insurance_btn) )
			}
		}()

		//加购电子商务
		document.addEventListener('cart:updated',(e)=>{
			const cart = e.detail.cart;
			// 判断是否是空购物车, 并且是否有上报过matomo,未上报过,且购物车为0 不上报购物车事件
			const has_matomo_cart = window.sessionStorage.getItem('has_matomo_cart')
			if ( Number(has_matomo_cart || cart.item_count ) ){
				_paq.push(['clearEcommerceCart']);
				cart.items.forEach(item=>{
					const itemEl = document.querySelector(`#CartDrawer .cart__items .cart__item[data-id="${item.id}"]`);
					let collections_arr=[];
					if(itemEl){
						const collections_str = itemEl.dataset?.collections || '';
						collections_arr = collections_str.split(",")
					}
					_paq.push([
						"addEcommerceItem",
						item.sku,
						item.product_title,
						collections_arr.slice(0,5),
						parseFloat(item.final_price / 100),
						item.quantity
					])
				})
				_paq.push(['trackEcommerceCartUpdate', parseFloat(cart.total_price / 100)]);
			}
			// 更新session matomo购物车标识
			window.sessionStorage.setItem('has_matomo_cart',cart.item_count)
		})

		//产品图片点击
		new MatomoHandle({
			container: window.document,
			category: 'imageChange',
			target: 'imageChange',
			event: 'slideChange',
			customTarget: (ev)=>{
				const container = ev.detail?.container;
				if (container){
					const el = document.createElement('div');
					if (container.classList.contains('is-modal')){
						el.dataset.matomoAction = 'quickView#@#product'
					}else{
						el.dataset.matomoAction = 'product#@#product'
					}
					el.dataset.matomoName = container.dataset?.productHandle||''
					el.dataset.matomoIndex = ev.detail?.index||"";
					el.dataset.matomoUrl = ev.detail?.mediaUrl||"";
					return el
				}else{
					return null
				}

			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})

		if (page_type === 'index' || page_handle === 'curve') {
			//首页轮播图
			Array.from(document.querySelectorAll('.slideshow-wrapper .hero'))
				.forEach(item=>{
					new MatomoHandle({
						container: item,
						category: 'bannerClick',
						target: 'slideshow'
					})
				})
			//首页irregular_gallery组件
			Array.from(document.querySelectorAll('.irregular-collection-section'))
			.forEach(item=>{
				new MatomoHandle({
					container: item,
					category: 'bannerClick',
					target: 'irregular_gallery'
				})
			})
			//首页Featured Sale
			new MatomoHandle({
				container: '.flash-sale-section',
				category: 'bannerClick',
				target: 'featuredSale'
			})
			//首页图片集
			Array.from(document.querySelectorAll('.photo-gallery, .image-gallery'))
				.forEach(item=>{
					new MatomoHandle({
						container: item,
						category: 'bannerClick',
						target: 'photo-gallery'
					})
				})
			//首页查看更多
			new MatomoHandle({
				container: '#MainContent',
				category: 'viewMoreClick',
				target: 'featured_all',
			})
			//首页tab模块菜单
			new MatomoHandle({
				container: '#MainContent',
				category: 'menuClick',
				target: 'featured_menu',
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			//首页产品点击
			new MatomoHandle({
				container: '#MainContent',
				category: 'productCardClick',
				target: 'product_card',
				customData: (el) => {
					let data = {}
					const cartItem = el.closest('.matomo-product-container');
					if (cartItem) {
						data.action = cartItem.dataset.matomoAction || '';
						data.name = cartItem.dataset.matomoName || '';
						data.index = cartItem.dataset.matomoIndex || '';
						data.url = cartItem.dataset.matomoUrl || '';
						data.sku = cartItem.dataset.matomoSku || '';
						data.size = cartItem.dataset.matomoSize || '';
						data.color = cartItem.dataset.matomoColor || '';
						data.price = cartItem.dataset.matomoPrice || '';
					}
					return {...data}
				}
			})
		}

		if (page_type === 'collection') {
			//集合页banner
			new MatomoHandle({
				container: ".collection-grid__wrapper .grid",
				category: 'bannerClick',
				target: 'collection_banner'
			})
			// 集合页banner 列表
			new MatomoHandle({
				container: ".collection-banner-list-inner",
				category: 'bannerClick',
				target: 'collection_banner_list'
			})
			//子菜单
			new MatomoHandle({
				container: ".collection-menu .collection-link-child",
				category: 'menuClick',
				target: 'collection#@#collectionMenu'
			})
			//集合页产品点击
			// TODO 产品评分点击无法捕获到,需要单独监控
			new MatomoHandle({
				container: '#CollectionAjaxContent .grid',
				category: 'productCardClick',
				target: 'product_card',
				customData: (el) => {
					let data = {}
					const cartItem = el.closest('.matomo-product-container');
					if (cartItem) {
						data.action = cartItem.dataset.matomoAction || '';
						data.name = cartItem.dataset.matomoName || '';
						data.index = cartItem.dataset.matomoIndex || '';
						data.url = cartItem.dataset.matomoUrl || '';
						data.sku = cartItem.dataset.matomoSku || '';
						data.size = cartItem.dataset.matomoSize || '';
						data.color = cartItem.dataset.matomoColor || '';
						data.price = cartItem.dataset.matomoPrice || '';
					}
					return {...data}
				}
			})
			//集合页banner code复制点击
			new MatomoHandle({
				container: document,
				category: 'codeCopy',
				target: 'codeCopy',
				event:'copied',
				customTarget: (ev) => {
					let el = null;
					if (ev.detail?.element){
						el = ev.detail.element
					}
					return el;
				},
				customData: (el) => {
					let data = {}
					const collectionHeaderSection = el.closest('#CollectionHeaderSection');
					if (collectionHeaderSection) {
						data.action = `collection#@#${collectionHeaderSection.dataset.collection}`;
						data.name = el.dataset.copyDom || '';
						const parent = el.parentNode;
						const children = parent.children;
						let index = 0;
						for (let i = 0; i < children.length; i++) {
							if (children[i] === el) {
								index = i;
								break;
							}
						}
						data.index = index + 1;
						const collectionImageEl = collectionHeaderSection.querySelector('.collection-hero__image');
						data.url = collectionImageEl.dataset.contentPiece
					}
					return {...data}
				}
			})
		}

		if (page_type === 'product') {
			new MatomoHandle({
				container: ".product-wrapper",
				category: 'productView',
				target: 'productView',
				event: 'sync',
				customData: (el,container) => {
					let data = {};
					if (container) {
						data.action = 'product#@#product';
						data.name = container.dataset.productHandle || '';
						data.url = container.dataset.matomoUrl || '';
						data.sku = container.dataset.currentSku || '';
						data.size = container.dataset.currentSize || '';
						data.color = container.dataset.currentColor || '';
						data.price = container.dataset.currentPrice || '';
					}
					return data
				},
			})

			//产品页banner
			new MatomoHandle({
				container: ".product-single__meta .custom_sale_banner",
				category: 'bannerClick',
				target: 'product_banner'
			})
			//产品页推荐产品点击
			new MatomoHandle({
				container: '.product-recommendations-container',
				category: 'productCardClick',
				target: 'product_card',
				customData: (el) => {
					let data = {}
					const cartItem = el.closest('.matomo-product-container');
					if (cartItem) {
						data.action = cartItem.dataset.matomoAction || '';
						data.name = cartItem.dataset.matomoName || '';
						data.index = cartItem.dataset.matomoIndex || '';
						data.url = cartItem.dataset.matomoUrl || '';
						data.sku = cartItem.dataset.matomoSku || '';
						data.size = cartItem.dataset.matomoSize || '';
						data.color = cartItem.dataset.matomoColor || '';
						data.price = cartItem.dataset.matomoPrice || '';
					}
					return {...data}
				}
			})

      //产品页尺码表按钮点击
      new MatomoHandle({
        container: '.page-content--product .product-single__meta .product-size-chart-btn',
        category: 'btnClick',
        target: 'sizeguide',
        callback: (el) => {
					el.dataset.matomoDisable = '';
				}
      })
			//产品页分享按钮点击
			new MatomoHandle({
				container: '.page-content--product .product-single__meta',
				category: 'shareClick',
				target: 'shareClick',
				customData: (el) => {
					let data = {}
          data.action = el.dataset.matomoAction || '';
					const cartItem = el.closest('.product-wrapper');
					if (cartItem) {
						data.name = cartItem.dataset.productHandle || '';
						data.sku = cartItem.dataset.currentSku || '';
						data.size = cartItem.dataset.currentSize || '';
						data.color = cartItem.dataset.currentColor || '';
						data.price = cartItem.dataset.currentPrice || '';
					}
					return {...data}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			//产品页加购按钮点击
			new MatomoHandle({
				container: '.page-content--product .product-single__meta .product-add',
				category: 'addToCartClick',
				target: 'addToCartClick',
				customData: (el) => {
					let data = {}
					data.action = 'product#@#addBtn'
					const cartItem = el.closest('.product-wrapper');
					if (cartItem) {
						const img_item = cartItem.querySelector('.product__thumb-item .product__thumb.is-active')
						data.name = cartItem.dataset.productHandle || '';
						data.index = '';
						data.url = cartItem.dataset.currentSkuImage || '';
						data.sku = cartItem.dataset.currentSku || '';
						data.size = cartItem.dataset.currentSize || '';
						data.color = cartItem.dataset.currentColor || '';
						data.price = cartItem.dataset.currentPrice || '';
					}
					return {...data}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			//产品页变体切换点击
			new MatomoHandle({
				container: '.product-wrapper:not(.is-modal)',
				category: 'skuChange',
				target: 'skuChange',
				event: 'variantChange',
				customTarget: (ev,container) => {
					const variant = ev.detail?.variant;
					let el = null;
					if (variant && container) {
						el = document.createElement('div');
						el.dataset.matomoAction= 'product#@#product';
						el.dataset.matomoName = container.dataset.productHandle || '';
						el.dataset.matomoSku = variant.sku || '';
						el.dataset.matomoIndex = ev.detail.index || '';
						el.dataset.matomoUrl = variant.featured_image?.src || '';
						el.dataset.matomoColor = variant.option1 || '';
						el.dataset.matomoSize = variant.option2 || '';
						el.dataset.matomoPrice = (variant.price / 100).toFixed(2);
						el.dataset.matomoTitle = container.dataset.productTitle || '';
						el.dataset.matomoCollections = container.dataset.productCollections || '';
					}
					return el
				},
				prevFn: (el,data) => {
					//产品页变体切换上报电子商务产品
					const hrefLogStr = sessionStorage.getItem('href_log') || '{}';
					const hrefLog = JSON.parse(hrefLogStr);
					const collectionsArr = el.dataset.matomoCollections.split(',').slice(0,5);
					_paq.push([
						'setEcommerceView',
						el.dataset.matomoSku,
						el.dataset.matomoTitle,
						collectionsArr,
						el.dataset.matomoPrice,
					]);
					_paq.push(['ping']);

					// 上报产品浏览
					const unit = Shopify.currency?.active || ''
					let productViewPrice ;
					if (data.price !== "" ){
						productViewPrice = `${unit} ${parseFloat(data.price).toFixed(2)}`
					}
					_paq.push([
						'trackEvent',
						'productView',
						'product#@#product',
						data.name,
						1,
						{
							dimension3: data.url,
							dimension5: data.sku,
							dimension6: data.size,
							dimension7: data.color,
							dimension8: productViewPrice,
							dimension9: data.landing || hrefLog?.landing || "",
							dimension10: data.prev || hrefLog?.prev || "",
							dimension11: data.current || hrefLog?.current || "",
							dimension12: bomType,
							dimension13: 'productView',
							dimension14: 'product#@#product',
							dimension15: data.name,
							dimension16: 	1,
						}
					]);
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			//产品页搭配购
			window.addEventListener('DOMContentLoaded',()=>{
				const container=document.querySelector('.product-single__meta');
				const callback = ()=> {
					const cbb = document.querySelector('.product-single__meta .cbb-frequently-bought-container')
					if(cbb != undefined){
						cbbOnload()
						observer.disconnect()
					}
				}
				const observer=new MutationObserver(callback)
				observer.observe(container,{childList:true,subtree:true})
				function cbbOnload() {
					//产品点击
					const cbb_product_list = document.querySelectorAll('.cbb-frequently-bought-product-image-link')
					cbb_product_list.forEach(item=>{
						item.addEventListener('click',(e)=>{
							const tarEl = e.target
							new MatomoHandle({
								container: tarEl,
								category: 'productCardClick',
								target: 'product_arab',
								event: 'sync',
								customData: (el) => {
									let data = {}
									let variantId =''
									data.action = 'product_arab'
									const href = item.dataset.href
									const imageEl = item.querySelector('.cbb-frequently-bought-product-image')
									if (imageEl){
										data.url = imageEl.style.backgroundImage;
									}
									if(href){
										data.href = href
										const hrefArr = href.split('/')
										const productInfo = hrefArr.find(item =>item.indexOf('variant')!== -1)
										if (productInfo){
											const infoArr = productInfo.split('?variant=')
											data.name = infoArr[0] || ''
											variantId = infoArr[1] || ''
										}
									}
									if (variantId){
										const optionEl = document.querySelector(`.cbb-frequently-bought-selector-list option[data-variant-id="${variantId}"]`)
										let options = optionEl.innerHTML.split('/')
										if(options.length<2){
											options = optionEl.innerHTML.split('-')
										}
										data.color = options[0] ? options[0].trim() : ''
										data.size = options[1] ? options[1].trim() : ''
										const liEl = optionEl.closest('li')
										if (liEl){
											const moneyEl = liEl.querySelector('.money');
											data.price = moneyEl.innerHTML.trim()
										}
									}
									return {...data}
								}
							})
						})
					})

					//产品加购
					const addBtn = document.querySelector('.cbb-frequently-bought-add-button')
					if(addBtn){
						addBtn.addEventListener('click',()=>{
							const list = document.querySelectorAll('.cbb-frequently-bought-recommendations-container li.cbb-frequently-bought-product')
							const liList  = Array.from(list).filter(item=>{
								return item.style.display !=='none'
							})
							liList.forEach(li=>{
								let data = {}
								data.action = 'product#@#arab'
								let variantId =''
								const imageEl = li.querySelector('.cbb-frequently-bought-product-image')
								if (imageEl){
									const background = imageEl.style.backgroundImage || '';
									data.url = background.slice(5,-2);
								}
								const aEl = li.querySelector('a.cbb-frequently-bought-product-image-link')
								if (aEl) {
									const href = aEl.dataset.href
									if(href){
										data.href = href
										const hrefArr = href.split('/')
										const productInfo = hrefArr.find(item =>item.indexOf('variant')!== -1)
										if (productInfo){
											const infoArr = productInfo.split('?variant=')
											data.name = infoArr[0] || ''
											variantId = infoArr[1] || ''
										}
									}
									if (variantId){
										const optionEl = document.querySelector(`.cbb-frequently-bought-selector-list option[data-variant-id="${variantId}"]`)
										const options = optionEl.innerHTML.split('/')
										data.color = options[0] ? options[0].trim() : ''
										data.size = options[1] ? options[1].trim() : ''
										const li = optionEl.closest("li")
										if (li){
											const moneyEl = li.querySelector('.money');
											if (moneyEl){
												data.price = moneyEl.innerHTML.trim()
											}
										}

									}
								}else{
									const productSection = document.querySelector('.product-section.product-wrapper')
									if (productSection){
										data.name = productSection.dataset.productHandle || ""
									}

									data.href = location.href
									let optionEl=null
									const selectEls =document.querySelectorAll('.cbb-frequently-bought-selector-list .cbb-recommendations-variant-select')
									const curSelect = selectEls[0]
									if (curSelect){
										const selectedIndex = curSelect.selectedIndex;
										optionEl = curSelect.options[selectedIndex]
									}
									if (optionEl){
										variantId = optionEl.dataset.variantId
										const optionHtml = optionEl.innerHTML.split('/')
										data.color = optionHtml[0] ? optionHtml[0].trim() : ''
										data.size = optionHtml[1] ? optionHtml[1].trim() : ''
										const liEl = optionEl.closest('li')
										if (liEl){
											const moneyEl = liEl.querySelector('.money');
											data.price = moneyEl.innerHTML.trim()
										}
									}
								}
								new MatomoHandle({
									container: li,
									category: 'addToCartClick',
									target: 'product_arab',
									event: 'sync',
									customData: () => {
										return {...data}
									}
								})
								if (variantId){
									localCartAddItem(variantId,'arab')
								}
							})
						})
					}
				}
			})

			// 自研搭配购加购埋点
			document.addEventListener('combinationProduct:submit', (ev) => {
				const productList = ev.detail.productList
				const combinationMode = ev.detail.combinationMode
				productList?.forEach(item => {
					new MatomoHandle({
						container: '.product-combination-wrapper',
						category: 'addToCartClick',
						target: 'product#@#combination',
						event: 'sync',
						customTarget: () => {
							return document.createElement('div')
						},
						customData: () => {
							let data = {
								action: 'product#@#combination',
								name: item.spu,
								index: item.index|| 1,
								url: item.variantImage,
                href: combinationMode,
								sku: item.variantSku,
								color: item.variantOption1,
								size: item.variantOption2,
								price:(item.variantPrice/100).toFixed(2),
							}
							return {...data}
						}
					})
				})

			})
			// 	最近浏览产品点击
			new MatomoHandle({
				container: '.section--recently-viewed',
				category: 'productCardClick',
				target: 'product_card',
				customData: (el) => {
					let data = {}
					const cardItem = el.closest('.grid__item.grid-product');
					if (cardItem) {
						data.action = 'product#@#recentlyViewed';
						data.name = cardItem.dataset.matomoName || '';
						data.index = cardItem.dataset.matomoIndex || '';
						data.url = cardItem.dataset.matomoUrl || '';
						data.sku = '';
						data.size = '';
						data.color = '';
						data.price = cardItem.dataset.matomoPrice || '';
					}
					return {...data}
				}
			})

			// 	评论翻页
			new MatomoHandle({
				container: '.review-wrapper',
				category: 'reviewsClick',
				target: 'reviewsClick',
				event: 'reviewPaginates',
				customTarget: (ev, container) => {
					let el = null;
					const page = ev.detail?.page;
					if ( container) {
						el = document.createElement('div');
						el.dataset.matomoAction= 'product#@#paginates';
						el.dataset.matomoName = container.dataset.productHandle || '';
						el.dataset.matomoIndex = page;
					}
					return el
				},
			})
			// 	评论图片查看
			new MatomoHandle({
				container: '#c_custom_review',
				category: 'reviewsClick',
				target: 'reviewsImage',
				customData: (el, container) => {
					const wrapper = container.querySelector('#ReviewsAllDrawer')
					const productHandle = wrapper?.dataset?.productHandle || '';
					const currentPage = wrapper?.dataset?.currentPage || 1;
					const itemEL = el.closest('.review-item');
					const index = itemEL?.dataset?.index || 0;
					const imgEL = el.querySelector('.jdgm-rev__pic-img');
					const imgSrc = imgEL?.dataset?.photoswipeSrc || '';
					let data = {}
					data.action = 'product#@#image';
					data.name = productHandle;
					data.value = 1;
					data.index = `${currentPage}-${index}`;
					data.url = imgSrc;
					return {...data}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
		}

		//自研收藏按钮点击
		if ( window.theme?.page_handle === 'wishlist'){
			// 移除收藏
			new MatomoHandle({
				container: document,
				event: 'wishRemove',
				category: 'wishlistClick',
				target: 'wishBtn',
				customTarget: (ev)=>{
					return ev.detail.target
				},
				customData: () => {
					return {action: 'wish#@#wish_remove'}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			// 移入购物车
			new MatomoHandle({
				container: document,
				event: 'wishMoveToCart',
				category: 'addToCartClick',
				target: 'wishBtn',
				customTarget: (ev)=>{
					return ev.detail.target
				},
				customData: () => {
					return {action: 'wish#@#addBtn'}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			// 点击收藏产品卡片
			new MatomoHandle({
				container: document,
				event: 'wishItemCLick',
				category: 'productCardClick',
				target: 'wishBtn',
				customTarget: (ev)=>{
					return ev.detail.target
				},
				customData: () => {
					return {action: 'wish#@#item'}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			// 点击收藏推荐
			new MatomoHandle({
				container: '.featured-collection .grid',
				category: 'productCardClick',
				target: 'product_card',
				customData: (el) => {
					let data = {}
					const cartItem = el.closest('.matomo-product-container');
					if (cartItem) {
						data.action = 'wish#@#recommend';
						data.name = cartItem.dataset.matomoName || '';
						data.index = cartItem.dataset.matomoIndex || '';
						data.url = cartItem.dataset.matomoUrl || '';
						data.sku = cartItem.dataset.matomoSku || '';
						data.size = cartItem.dataset.matomoSize || '';
						data.color = cartItem.dataset.matomoColor || '';
						data.price = cartItem.dataset.matomoPrice || '';
					}
					console.log(data)
					return {...data}
				}
			})
		}else {
			// 移除收藏
			new MatomoHandle({
				container: document,
				event: 'wishRemove',
				category: 'wishlistClick',
				target: 'wishBtn',
				customTarget: (ev)=>{
					return ev.detail.target
				},
				customData: (el) => {
					let data = {}
					const cartItem = el.closest('.product-wrapper');
					if (cartItem) {
						data.action = cartItem.dataset.modal === 'true' ? 'quickView#@#wish_remove' : 'product#@#wish_remove' ;
						data.url = cartItem.dataset.currentSkuImage || '';
						data.sku = cartItem.dataset.currentSku || '';
						data.size = cartItem.dataset.currentSize || '';
						data.color = cartItem.dataset.currentColor || '';
						data.price = cartItem.dataset.currentPrice || '';
					}
					return {...data}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			// 添加收藏
			new MatomoHandle({
				container: document,
				event: 'wishAdd',
				category: 'wishlistClick',
				target: 'wishBtn',
				customTarget: (ev)=>{
					return ev.detail.target
				},
				customData: (el) => {
					let data = {}
					const cartItem = el.closest('.product-wrapper');
					if (cartItem) {
						data.action = cartItem.dataset.modal === 'true' ? 'quickView#@#wish_add' : 'product#@#wish_add' ;
						data.url = cartItem.dataset.currentSkuImage || '';
						data.sku = cartItem.dataset.currentSku || '';
						data.size = cartItem.dataset.currentSize || '';
						data.color = cartItem.dataset.currentColor || '';
						data.price = cartItem.dataset.currentPrice || '';
					}
					return {...data}
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})

      // 	评论View all 打开
      new MatomoHandle({
        container: '#c_custom_review',
        category: 'reviewsClick',
        target: 'review#@#viewAll',
        event: 'drawerOpen',
        customData: (el) => {
          const productHandle = el?.dataset?.productHandle || '';
          return {
            action: 'product#@#viewAll',
            name : productHandle,
            value : 1,
          }
        },
        callback: (el) => {
          el.dataset.matomoDisable = '';
        }
      })

      // 	评论 关闭
      new MatomoHandle({
        container: '#c_custom_review',
        category: 'reviewsClick',
        target: 'reviewsClick',
        event: 'drawerClose',
        customTarget: (ev,container)=>{
          return container.querySelector('#ReviewsAllDrawer') || null
        },
        customData: (el) => {
          const productHandle = el?.dataset?.productHandle || '';
          const openTime =(el?.dataset.openTime || '0') * 1;
          const time = new Date().getTime() - openTime;
          return {
            action: 'product#@#viewClose',
            name : productHandle,
            value : 1,
            index: time,
          }
        },
        callback: (el) => {
          el.dataset.matomoDisable = '';
        }
      })
      // 评论 Next
      document.addEventListener('reviewFormNextStep', (ev) => {
        new MatomoHandle({
          container: '.product-section.product-wrapper',
          category: 'btnClick',
          event: 'sync',
          customTarget: () => {
            return document.createElement('div')
          },
          customData: (el) => {
            const productHandle = el?.dataset?.productHandle || '';
            const price = (el?.dataset?.currentPrice || '0') * 1;
            const { validated, rating, body, mediaCount, name, email } = ev?.detail || {};
            return {
              action: 'review#@#step1next',
              name: productHandle,
              value: rating,
              index: body?.length || 0,
              url: name,
              href: email,
              size: mediaCount > 0 ? `${mediaCount}` : '0',
              color: validated ? '1' : '0',
              price: price,
            }
          },
          callback: (el) => {
            el.dataset.matomoDisable = '';
          }
        })
      })
      // 评论 Submit
      document.addEventListener('reviewFormSubmit', (ev) => {
        new MatomoHandle({
          container: '.product-section.product-wrapper',
          category: 'btnClick',
          event: 'sync',
          customTarget: () => {
            return document.createElement('div')
          },
          customData: (el) => {
            const productHandle = el?.dataset?.productHandle || '';
            const price = (el?.dataset?.currentPrice || '0') * 1;
            const { validated, rating, body, mediaCount, name, email, page2Answers } = ev?.detail || {};
            return {
              action: 'review#@#submit',
              name: productHandle,
              value: rating,
              index: body?.length || 0,
              url: name,
              href: email,
              size: mediaCount > 0 ? `${mediaCount}` : '0',
              color: validated ? '1' : '0',
              price: price,
              sku: page2Answers,
            }
          },
          callback: (el) => {
            el.dataset.matomoDisable = '';
          }
        })
      })
      // 评论 Prev
      document.addEventListener('reviewFormPrevStep', (ev) => {
        new MatomoHandle({
          container: '.product-section.product-wrapper',
          category: 'btnClick',
          event: 'sync',
          customTarget: () => {
            return document.createElement('div')
          },
          customData: (el) => {
            const productHandle = el?.dataset?.productHandle || '';
            const price = (el?.dataset?.currentPrice || '0') * 1;
            return {
              action: 'review#@#step1back',
              name: productHandle,
              price: price,
            }
          },
          callback: (el) => {
            el.dataset.matomoDisable = '';
          }
        })
      })

		}

		if (page_type === 'search') {
			//搜索页产品点击
			new MatomoHandle({
				container: '#MainContent',
				category: 'productCardClick',
				target: 'product_card',
				customData: (el) => {
					let data = {}
					const cartItem = el.closest('.matomo-product-container');
					if (cartItem) {
						data.action = cartItem.dataset.matomoAction || '';
						data.name = cartItem.dataset.matomoName || '';
						data.index = cartItem.dataset.matomoIndex || '';
						data.url = cartItem.dataset.matomoUrl || '';
						data.sku = cartItem.dataset.matomoSku || '';
						data.size = cartItem.dataset.matomoSize || '';
						data.color = cartItem.dataset.matomoColor || '';
						data.price = cartItem.dataset.matomoPrice || '';
					}
					return {...data}
				}
			})

			//搜索页irregular_gallery组件
			Array.from(document.querySelectorAll('.photo-gallery, .image-gallery'))
				.forEach(item=>{
					new MatomoHandle({
						container: item,
						category: 'bannerClick',
						target: 'photo-gallery'
					})
				})
		}

		// 	下载引导点击(header)
		new MatomoHandle({
			container: '#SiteHeader .app-download-bar',
			category: 'appDownloadClick',
			target: 'app_download_link',
		})
		// 	下载引导点击(footer)
		new MatomoHandle({
			container: '.site-footer .footer-download-wrapper .download-icons-app',
			category: 'appDownloadClick',
			target: 'app_download_link',
		})
		// 	下载引导点击(drawer)
		new MatomoHandle({
			container: '#NavDrawer .mobile-nav__download .download-icons-app',
			category: 'appDownloadClick',
			target: 'app_download_link',
		})
		//  自定义页面下载引导点击
		if (page_type === 'page') {
			new MatomoHandle({
				container: '.page-download-app',
				category: 'appDownloadClick',
				target: 'app_download_link',
			})
		}
		//  运费差异化美区弹窗点击
		new MatomoHandle({
			container: document,
			category: 'popClick',
			target: 'micas-shipping-tip-popup-view-more',
		})

		//  取消订阅页面
		if (page_handle === 'edm-unsubscribe') {
			const search = window.location.search;
			const searchObj = new URLSearchParams(search)
			const unsubscribeChannelType = searchObj.get('emailChannelType') || '0'
			const unsubscribeEmail = searchObj.get('submitEmail') || '';
			// 页面浏览
			new MatomoHandle({
				container: document.documentElement,
				event: 'sync',
				category: 'new_pageview',
				customData: () => {
					let data = {}
					data.action = 'pages#@#unsubscribe';
					data.name = 'unsubscribe_view';
					data.value = Number(unsubscribeChannelType) || '';
					data.sku = unsubscribeEmail;
					data.url = location.href
					return {...data}
				}
			})

			//  确认 退订
			new MatomoHandle({
				container: '#page-unsubscribe-edm .unsubscribe-reason-page',
				category: 'menuClick',
				target: 'unsubscribe',
				customData: () => {
					let data = {}
					const reasonSelectList = document.querySelectorAll('#page-unsubscribe-edm .reason-select-box-item input')
					const reasonList = Array.from(reasonSelectList).filter(item => item.checked)
					let reasonListStr = ''
					if (reasonList?.length) {
						const reasonListIndex = reasonList.map(item => Number(item.dataset.matomoIndex))
						reasonListStr = JSON.stringify(reasonListIndex);
					}
					data.value = Number(unsubscribeChannelType) || '';
					data.index = reasonListStr;
					data.sku = unsubscribeEmail;
					return {...data}
				}
			})
			//  取消 退订
			new MatomoHandle({
				container: '#page-unsubscribe-edm .unsubscribe-reason-page',
				category: 'menuClick',
				target: 'cancel_unsubscribe',
				customData: () => {
					let data = {}
					const reasonSelectList = document.querySelectorAll('#page-unsubscribe-edm .reason-select-box-item input')
					const reasonList = Array.from(reasonSelectList).filter(item => item.checked)
					let reasonListStr = ''
					if (reasonList?.length) {
						const reasonListIndex = reasonList.map(item => Number(item.dataset.matomoIndex))
						reasonListStr = JSON.stringify(reasonListIndex);
					}
					data.value = Number(unsubscribeChannelType) || '';
					data.index = reasonListStr;
					data.sku = unsubscribeEmail;
					return {...data}
				}
			})
			//  弹窗 取消
			new MatomoHandle({
				container: '#page-unsubscribe-edm #unsubscribeEdmModal',
				category: 'menuClick',
				target: 'retain_unsubscribe_no',
				customData: () => {
					let data = {}
					const reasonSelectList = document.querySelectorAll('#page-unsubscribe-edm .reason-select-box-item input')
					const reasonList = Array.from(reasonSelectList).filter(item => item.checked)
					let reasonListStr = ''
					if (reasonList?.length) {
						const reasonListIndex = reasonList.map(item => Number(item.dataset.matomoIndex))
						reasonListStr = JSON.stringify(reasonListIndex);
					}
					data.value = Number(unsubscribeChannelType) || '';
					data.index = reasonListStr;
					data.sku = unsubscribeEmail;
					return {...data}
				}
			})
			//  弹窗 确认
			new MatomoHandle({
				container: '#page-unsubscribe-edm #unsubscribeEdmModal',
				category: 'menuClick',
				target: 'retain_unsubscribe_yes',
				customData: () => {
					let data = {}
					const reasonSelectList = document.querySelectorAll('#page-unsubscribe-edm .reason-select-box-item input')
					const reasonList = Array.from(reasonSelectList).filter(item => item.checked)
					let reasonListStr = ''
					if (reasonList?.length) {
						const reasonListIndex = reasonList.map(item => Number(item.dataset.matomoIndex))
						reasonListStr = JSON.stringify(reasonListIndex);
					}
					data.value = Number(unsubscribeChannelType) || '';
					data.index = reasonListStr;
					data.sku = unsubscribeEmail;
					return {...data}
				}
			})
			// 	继续浏览
			new MatomoHandle({
				container: '#page-unsubscribe-edm .continuing-subscribe-page',
				category: 'menuClick',
				target: 'continue_shopping',
				customData: () => {
					let data = {}
					const reasonSelectList = document.querySelectorAll('#page-unsubscribe-edm .reason-select-box-item input')
					const reasonList = Array.from(reasonSelectList).filter(item => item.checked)
					let reasonListStr = ''
					if (reasonList?.length) {
						const reasonListIndex = reasonList.map(item => Number(item.dataset.matomoIndex))
						reasonListStr = JSON.stringify(reasonListIndex);
					}
					data.value = Number(unsubscribeChannelType) || '';
					data.index = reasonListStr;
					data.sku = unsubscribeEmail;
					return {...data}
				}
			})
			// 	成功继续浏览
			new MatomoHandle({
				container: '#page-unsubscribe-edm .unsubscription-successful-page',
				category: 'menuClick',
				target: 'continue_shopping',
				customData: () => {
					let data = {}
					const reasonSelectList = document.querySelectorAll('#page-unsubscribe-edm .reason-select-box-item input')
					const reasonList = Array.from(reasonSelectList).filter(item => item.checked)
					let reasonListStr = ''
					if (reasonList?.length) {
						const reasonListIndex = reasonList.map(item => Number(item.dataset.matomoIndex))
						reasonListStr = JSON.stringify(reasonListIndex);
					}
					data.value = Number(unsubscribeChannelType) || '';
					data.index = reasonListStr;
					data.sku = unsubscribeEmail;
					return {...data}
				}
			})
		}
		//订阅
		new MatomoHandle({
			container: '.site-footer .footer__newsletter',
			category: 'menuClick',
			target: 'footer_subscribe',
			customData: (el, content) => {
				const emailInput = content.querySelector('.footer__newsletter-input')
				const email = emailInput.value || ''
				let data = {}
				data.sku= email
				return {...data}
			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
		// 会员中心
		if (page_type === 'page' && page_handle === 'micas-rewards') {
			//会员中心兑换点击
			new MatomoHandle({
				container: '#MainContent .micas-member-page',
				category: 'memberClick',
				target: 'member_btn',
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			//会员中心兑换
			new MatomoHandle({
				container: '#MemberRedeemModal',
				category: 'memberClick',
				target: 'member_btn',
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			// 积分记录
			new MatomoHandle({
				container: '#MemberRecordsModal',
				category: 'memberClick',
				target: 'member_btn',
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			new MatomoHandle({
				container: '#MemberRecordsDrawer',
				category: 'memberClick',
				target: 'member_btn',
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
			//会员中心生日提交
			new MatomoHandle({
				container: '#MemberEditDateModal',
				event: 'save-birthday',
				category: 'memberClick',
				customTarget: (ev, container) => {
					const date = ev.detail?.date || 0;
					const el = document.createElement('div');
					el.dataset.matomoAction= 'member#@#savebirth';
					el.dataset.matomoName = '1';
					el.dataset.matomoIndex = '1';
					el.dataset.matomoColor = date.toString();
					return el
				},
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
		}
		// 	购物车 打开
		new MatomoHandle({
			container: '#CartDrawer',
			category: 'popDisplay',
			target: 'popDisplay',
			event: 'drawerOpen',
			customTarget: (ev,container)=>{
				return container
			},
			customData: (el) => {
				return { action: 'cart#@#pop' }
			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
		window.addEventListener('DOMContentLoaded', ()=>{
			const cartDrawer = document.querySelector('#CartDrawer')
			if(cartDrawer.classList.contains('drawer--is-open')){
				new MatomoHandle({
					container: cartDrawer,
					category: 'popDisplay',
					target: 'popDisplay',
					event: 'sync',
					customTarget: (ev,container)=>{
						return container
					},
					customData: (el) => {
						return { action: 'cart#@#pop' }
					},
					callback: (el) => {
						el.dataset.matomoDisable = '';
					}
				})
			}
		})
		// 购物车 触发加购未转化条件
		new MatomoHandle({
			container: document,
			event: 'transactionOptimizationCouponConditionmet',
			category: 'rewardClick',
			customTarget: (ev)=>{
				const el = document.createElement('div');
				el.dataset.matomo = ev.detail?.dataset?.matomo
				el.dataset.matomoColor = ev.detail?.dataset?.matomoColor || "";
				el.dataset.matomoName = ev.detail?.dataset?.matomoName || "";
				el.dataset.matomoIndex = ev.detail?.dataset?.matomoIndex || "";
				el.dataset.matomoDisable = ev.detail?.dataset?.matomoDisable || "";
				return el
			}
		})
		// 购物车 点击兑换折扣码
		new MatomoHandle({
			container: '#CartCouponModal',
			category: 'rewardClick',
			target: 'cart_coupon_reward_btn',
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
		//购物车 点击使用折扣码
		new MatomoHandle({
			container: '#CartCouponModal',
			category: 'rewardClick',
			target: 'cart_coupon_use_btn',
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
		// 购物车 复制折扣码
		new MatomoHandle({
			container: '#CartCouponModal',
			category: 'rewardClick',
			target: 'cart_coupon_copy_btn',
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})

		// 购物车 点击折扣码倒计时提示
		new MatomoHandle({
			container: "#CartDrawer",
			category: 'rewardClick',
			target: 'cart#@#codehint',
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
		//登录态切换
		window.addEventListener('DOMContentLoaded', ()=> {
			let m_form = '';
			// 如果是登录页, 更新来源
			if (window.theme?.page_type  === 'customers/login'){
				const search = window.location.search;
				const searchObj = new URLSearchParams(search)
				m_form = searchObj?.get('m_form') || ''
			}
			const preLoginCustomer = micasSessionStorage.getJson('@micas-loginCustomer') || '{}';
			const loginCustomer = {
				id: window.customer?.id,
				email: window.customer?.email,
				m_form: m_form || 'none',
			}
			micasSessionStorage.setJson('@micas-loginCustomer', loginCustomer)
			// 登出: 登录=>未登录
			if (preLoginCustomer?.id && !loginCustomer.id){
				new MatomoHandle({
					container: document.documentElement,
					event: 'sync',
					category: 'userInfo',
					customData: () => {
						let data = {}
						data.action = 'signOut';
						data.name = '';
						data.value = 1;
						data.shopifyId = preLoginCustomer.id;
						data.shopifyEmail = preLoginCustomer.email
						return {...data}
					}
				})
			}
			// 登录: 未登录=>登录
			if (!preLoginCustomer?.id && loginCustomer.id){
				new MatomoHandle({
					container: document.documentElement,
					event: 'sync',
					category: 'userInfo',
					customData: (ev) => {
						let data = {}
						data.action = 'login';
						data.value = 1;
						data.size = preLoginCustomer?.m_form || 'none';
						data.shopifyId = loginCustomer.id;
						data.shopifyEmail = loginCustomer.email
						return {...data}
					}
				})
			}

		})
    // 	M端分享弹窗 打开
    new MatomoHandle({
      container: '#ShareDrawer',
			category: 'btnClick',
			target: 'btnClick',
			event: 'drawerOpen',
      customTarget: (ev,container)=>{
				return container
			},
      customData: (el) => {
				let data = {}
        data.action = "product#@#share"
				const productWrapper = el.closest('.product-wrapper');
				if (productWrapper) {
					data.name = productWrapper.dataset.productHandle || '';
					data.index = productWrapper.dataset.matomoIndex || '';
					data.url = productWrapper.dataset.currentSkuImage || '';
					data.sku = productWrapper.dataset.currentSku || '';
					data.size = productWrapper.dataset.currentSize || '';
					data.color = productWrapper.dataset.currentColor || '';
					data.price = productWrapper.dataset.currentPrice || '';
				}
				return {...data}
			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
    //  尺码弹窗 打开
		new MatomoHandle({
			container: document,
			category: 'btnClick',
			event: 'MySizeModalOpen',
			customTarget: (ev)=>{
				const target = ev.detail?.target;
				return target || document.createElement('div');
			},
			customData: (el) => {
        let data = {
          action: 'mysize_entry',
          name: ''
        }
        if (el.closest('.product-size-set-guide')){
          data.name = 'pdp_bar'
        }
        if (el.closest('#SizeChartModal')){
          data.name = 'sizeguide_pop'
        }
        if (el.closest('.micas-member-page')){
          data.name = 'rewards_task'
        }
				return { ...data }
			},
			callback: (el) => {
				el.dataset.matomoDisable = '';
			}
		})
    // 尺码保存
    new MatomoHandle({
      container: document,
      category: 'btnClick',
      target: 'my_size_save_btn',
      callback: (el) => {
        el.dataset.matomoDisable = '';
      }
    })

		// cartSee 新人弹窗埋点
		const handleCartxEmailSubmit = function (event) {
			const cartxButton = event.target.closest('#cartx-wrap .cartx-b-button');
			if (!cartxButton) {
				return;
			}
			const cartxEmail = document.querySelector('#cartx-wrap .cartx-form-wrapper #email_input');
			const email = cartxEmail?.value || '';
			if (!email || !email.trim()) {
				return;
			}
			new MatomoHandle({
				container: cartxButton,
				category: 'btnClick',
				event: 'sync',
				customData: () => {
					let data = {
						action:'cartx_email',
						name: email.trim(),
						value: 1,
					}
					return {...data}
				}
				,
				callback: (el) => {
					el.dataset.matomoDisable = '';
				}
			})
		};
		document.addEventListener('click', handleCartxEmailSubmit);
	}()

}catch (e) {
	console.log(e)
}

